import { IBasicCancelProceedPopupProps } from '../../../../components/popups/BasicCancelProceedPopup/BasicCancelProceedPopup.types';
import BasicCancelProceedPopup from '../../../../components/popups/BasicCancelProceedPopup/BasicCancelProceedPopup';

const RemoveItemPopup = (props: IBasicCancelProceedPopupProps) => {
    const { showPopup, onDialogClose } = props;

    return (
        <BasicCancelProceedPopup
            showPopup={showPopup}
            onDialogClose={onDialogClose}
            popupHeader={'Are You Sure?'}
            popupText={'This item will be removed from your cart.'}
        />
    );
};

export default RemoveItemPopup;
